import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";

import CustomerList from "../Sections/Component/CustomerList";
import AccountDetails from "../Sections/Component/AccountDetails";
import SubscriptionDetails from "../Sections/Component/SubscriptionDetails";

const useStyles3 = makeStyles(javascriptStyles);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const CustomerSubscriptionDetails = ({}) => {
	const classes3 = useStyles3();
	const classesCSStyles = useStylesCustomerDetailsStyles();

	return (
		<div className={classNames(classes3.py5)}>
			<div className={classNames("flex")}>
				<div className={classNames(classesCSStyles.leftSide)}>
					<CustomerList />
				</div>
				<div className={classNames(classesCSStyles.rightSide)}>
					<SubscriptionDetails />
					<AccountDetails />
				</div>
			</div>
		</div>
	);
};

export default CustomerSubscriptionDetails;
